<template>
  <div class="propertycontrol">
    <div class="header">
      <div class="title">移动综合管控</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        后台智能数据统计，一键分析，针对人员管理、流程审批、待办事项等事宜在线进行综合管控，提高物业管理能力。
      </div>

      <div class="right">
        <div class="position">
          <img :src="propertycontrol2" alt="" />
          <img :src="propertycontrol3" alt="" />
          <img :src="propertycontrol4" alt="" />
        </div>
        <div class="logo">
          <img :src="propertycontrol1" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import propertycontrol1 from "../../../../assets/product/propertycontrol1.png";
import propertycontrol2 from "../../../../assets/product/propertycontrol2.png";
import propertycontrol3 from "../../../../assets/product/propertycontrol3.png";
import propertycontrol4 from "../../../../assets/product/propertycontrol4.png";

export default {
  setup() {
    return reactive({
      propertycontrol1: propertycontrol1,
      propertycontrol2: propertycontrol2,
      propertycontrol3: propertycontrol3,
      propertycontrol4: propertycontrol4,
    });
  },
};
</script>

<style scoped>
.propertycontrol {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.body .right {
  display: flex;
  position: relative;
}
.body .right .logo img {
  width: 332px;
  margin-left: 20px;
}
.body .right .position img {
  width: 236px;
  position: absolute;
}
.body .right .position img:nth-of-type(1) {
  right: 100%;
}
.body .right .position img:nth-of-type(2) {
  right: 125%;
  bottom: 0;
}
.body .right .position img:nth-of-type(3) {
  right: 150%;
  bottom: 0;
}
.body .left {
  width: 480px;
  font-size: 16px;
  color: #3d3d3d;
  line-height: 24px;
}
</style>
